import type { CommandPaletteGroup } from '@nuxt/ui'

export const useGlobalShortcuts = createSharedComposable(() => {
  const viewShortcutsHook = createEventHook()

  const GENERAL_SHORTCUTS = [
    {
      label: 'View keyboard shortcuts',
      icon: 'i-lucide-keyboard',
      kbds: ['meta', '/'],
      onSelect() {
        viewShortcutsHook.trigger()
      },
    },
    {
      label: 'Log out',
      icon: 'i-lucide-log-out',
      to: '/logout',
      kbds: ['meta', 'shift', 'Q'],
      onSelect() {
        navigateTo('/logout')
      },
    },
  ]

  const TOP_MENU_NAV_ITEMS = [
    {
      label: 'Dashboard',
      icon: 'i-lucide-house',
      to: '/dashboard',
      kbds: ['G', 'D'],
      onSelect() {
        navigateTo('/dashboard')
      },
    },
    {
      label: 'Settings',
      icon: 'i-lucide-settings',
      to: '/settings',
      kbds: ['G', 'S'],
      onSelect() {
        navigateTo('/settings')
      },
    },
  ]

  const NAVIGATION_SHORTCUTS = [...TOP_MENU_NAV_ITEMS]

  defineShortcuts({
    ...extractShortcuts(GENERAL_SHORTCUTS),
    ...extractShortcuts(NAVIGATION_SHORTCUTS, '-'),
  })

  return {
    all: [
      {
        id: 'general',
        label: 'General',
        items: GENERAL_SHORTCUTS,
      },
      {
        id: 'navigation',
        label: 'Navigation',
        items: NAVIGATION_SHORTCUTS,
      },
    ] satisfies CommandPaletteGroup[],
    navigation: NAVIGATION_SHORTCUTS,
    topMenuItems: TOP_MENU_NAV_ITEMS,
    general: GENERAL_SHORTCUTS,
    onViewShortcuts: viewShortcutsHook.on,
  }
})
